(function () {
  var attrs = {};

  function collectUtmsFromParams(params) {
    if (!params) return;
    params.forEach(function (value, key) {
      if (!value || !key) return;
      if (key.toLowerCase().indexOf("utm") === 0) {
        attrs[key] = value;
      }
    });
  }

  if (window.location.search) {
    try {
      var urlParams = new URLSearchParams(window.location.search);
      collectUtmsFromParams(urlParams);
    } catch (e) {
    }
  }

  if (Object.keys(attrs).length === 0 && document.referrer) {
    try {
      var refUrl = new URL(document.referrer);
      collectUtmsFromParams(refUrl.searchParams);

      if (refUrl.href) {
        attrs.sy_original_referrer = refUrl.href;
      }
    } catch (e) {
    }
  }

  if (Object.keys(attrs).length === 0) return;

  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    body: JSON.stringify({ attributes: attrs })
  }).catch(function (err) {
    if (window.console && console.error) {
      console.error("UTM cart attribute error", err);
    }
  });
})();